import { useState, useEffect } from "react";
import { checkUserPermission } from "../../../../common/UserPermission";
import Select from "react-select";
import axios from "axios";
import {CUSTOM_SELECT_DROPDOWN_STYLE} from "../../../../common/Constant";
import config from "../../../../config/config";
import JournalEntry from "./JournalEntry";

let PERMISSION_DELETE = "delete-attributes";


// export function GetDataForCredit(sumcredit) {
//   return sumcredit;
// }

export default function JournalTableRows({
  rowsData,
  deleteTableRows,
  handleChange,
  callback,
  
}) {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [debits, setdebits] = useState([]);
  const [credits, setcredits] = useState([]);
  const [debitsTotal, setdebitsTotal] = useState(0);
  const [creditsTotal, setcreditsTotal] = useState(0);
  const [TransferFundsFrom, setTransferFundsFrom] = useState([]);
  const [AppointmentForPerson, setAppointmentForPerson] = useState([]);
  const token = localStorage.getItem("Token");
  const [data,setData]=useState(false)
  const [state,setState]=useState([])

  useEffect(() => {
    setState(rowsData)
  }, [rowsData])
  
  console.log("state 37", state)


  useEffect(()=>{

    if(rowsData.length==0){
      callback(0,"debit")
      callback(0,"credit")
    }else{

    
    sumofdebit=0
    rowsData?.forEach((data) => {
      sumofdebit = parseFloat(sumofdebit) + parseFloat(data.debits>=0 ? Number(data.debits):0);
    callback(sumofdebit,"debit");
    // return updatedData;
  });

  sumofcredit = 0;

  rowsData?.forEach((data) => {
    sumofcredit = parseFloat(sumofcredit) + parseFloat(data.credits>=0 ? Number(data.credits):0);
  callback(sumofcredit,"credit");
  // return updatedData;
});
    }
  },[rowsData])
  
  let sumofdebit = 0;
  let sumofcredit = 0;

 


  let sumdebit;
  console.log(rowsData,"rowsData")


 const updateDataForDebit=(p_debitdata)=> {
  sumdebit = p_debitdata;
  callback(sumdebit,"debit")
  console.log(sumdebit,"sumdebit")
  
  // return sumdebit;
  
}

// export function GetDataForDebit(sumdebit) {
  
//   return sumdebit;
// }
let sumcredit;

 const updateDataForCredit=(p_creditdata)=> {
  sumcredit = p_creditdata;
  console.log(sumcredit,"sumcredit")
  callback(sumcredit,"credit")
  
}


  const handleDeleteClick = (index) => {
    setDeleteIndex(index);
    setShowDeleteModal(true);
  };

  

  // const handleInputClick=(val)=>{
  //   // console.log(rowsData,"rowsData34")
  //   if(val=="debits"){
     
  //     updateDataForDebit(sumofdebit);
  //   }

  //   if(val=="credits"){
     
  //     updateDataForCredit(sumofcredit);
  //   }
   
  // }



  // let newRowsData=[...rowsData]
  const handleInputBoxChange = (index, field, value) => {
   
    // console.log("index, field, value 92", index, field, value)
    
    
    // const newRowsData = [...rowsData];
    // console.log(rowsData,"rowsData")
    // newRowsData[index][field] = value;

    if (field === "debits") {

      setState((prev) => {
        const updatedData = [...prev];
        updatedData[index]["credits"] = 0;
        sumofcredit=0
        updatedData.forEach((data) => {
        sumofcredit = parseFloat(sumofcredit) + parseFloat(data.credits>=0 ? Number(data.credits):0);
        callback(sumofcredit,"credit");
        // return updatedData;
      });
      updatedData[index][field] = value;
      updatedData.forEach((data) => {
        sumofdebit = parseFloat(sumofdebit) + parseFloat(data.debits>=0 ? Number(data.debits):0);
        callback(sumofdebit,"debit")
        // return updatedData
      })
      return updatedData
      });

    } else {


      setState((prev) => {
        const updatedData = [...prev];
        updatedData[index]["debits"] = 0;
        sumofdebit=0
        updatedData.forEach((data) => {
          sumofdebit = parseFloat(sumofdebit) + parseFloat(data.debits>=0 ? Number(data.debits):0);
        callback(sumofdebit,"debit");
        // return updatedData;
      });
      updatedData[index][field] = value;
      updatedData.forEach((data) => {
        sumofcredit = parseFloat(sumofcredit) + parseFloat(data.credits>=0 ? Number(data.credits):0);
        callback(sumofcredit,"credit")
        
      })
      return updatedData
        
      });


    
     
      // newRowsData.forEach((data) => {
      //   sumofdebit = parseFloat(sumofdebit) + parseFloat(data.debits>=0 ? data.debits:"");
      //   updateDataForDebit(sumofdebit);
      // });


      // setState((prev) => {
      //   const updatedData = [...prev];
      //   updatedData[index][field] = value;
      //   updatedData.forEach((data) => {
      //     sumofcredit = parseFloat(sumofcredit) + parseFloat(data.credits>=0 ? data.credits:0);
      //     callback(sumofcredit,"credit")
      //     return updatedData
      //   })
      // });




      // newRowsData.forEach((data) => {
      //   sumofcredit = parseFloat(sumofcredit) + parseFloat(data.credits>=0 ? data.credits:"");
      //   updateDataForCredit(sumofcredit);
      // });
      // console.log(sumofcredit,"sumofcredit")
      // setcreditsTotal(sumofcredit);
    }
  };

  console.log(state,"state456")

 //Styles
//  const selectStyles = {
//   // dropdown input css
//   control: (provided, state) => ({
//     ...provided,
//     width: "100%",
//     height: "40px",
//     position: "relative",
//     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
//     boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
//     "&:hover": {
//       border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
//     },
//   }),
//   // dropdown menu css
//   menu: () => ({
//     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
//     position: "absolute",
//     "z-index": "999",
//     background: "#f8f8f8",
//     color:"#000",
//     width: "100%",
//   }),
//   // dropdown option css
//   option: (provided, state) => ({
//     ...provided,
//     color:state.isActive?"#000":"#000",
//     backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
//     "&:hover": {
//       color: "#000",
//       backgroundColor: "rgba(255, 159, 67, 0.8)", // change hover color to light orange
//     },
//   }),
// };

  const handleConfirmDelete = () => {
    
    deleteTableRows(deleteIndex);
    console.log(state,"state65")
   
   
    setShowDeleteModal(false);
    // sumofcredit = 0;
    updateDataForDebit(sumofdebit);
    // sumofdebit = 0;
    setcreditsTotal(sumofcredit);
  };

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
  };

  const handleVariation = (index, event) => {
    let evnt = {
      target: {
        name: "accountid",
        value: event.value,
        quickbookid: event.QuickbookId,
        AccountName: event.AccountName
      },
    };
    handleChange(index, evnt);
  };

  const handleName = (index, event) => {
    console.log("event", event);
    let evnt = {
      target: {
        name: "userid",
        value: event.value,
        IsCustomer: event.IsCustomer,
        appointmentquickbookid: event.AppointmentQuickbookId
      },
    };

    handleChange(index, evnt);
  };

  const handleUserType = (index, event) => {
    console.log("event", event);
    let evnt = {
      target: {
        name: "usertype",
        value: event.IsCustomer,
      },
    };

    handleChange(index, evnt);
  };

  useEffect(() => {
    axios
      .get(`${config.accountingBaseUrl}/chartofaccounts/accountddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("response ==>", res.data.ResponseData);
        setTransferFundsFrom(res.data.ResponseData);
      });

    axios
      .get(`${config.appointmentBaseUrl}/appointments/appointmentpersonddl?isCustomer=0`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setAppointmentForPerson(res.data.ResponseData);
        console.log("res ", res.data.ResponseData);
      });
  }, []);

  const handleClose = () => {
    setShowDeleteModal(false);
  };

  console.log(rowsData,"rowsData")
  console.log(TransferFundsFrom,"TransferFundsFrom")
  console.log(state,"state")
  if (state!="")
    return state.map((data, index) => {
      const { journalitemid, accountid, debits, credits, description, userid,usertype, AccountName } =
        data;
   
      let categoryOption = [];
      const FundsFrom = TransferFundsFrom.map((u, i) => {
        categoryOption[i] = { label: u.Name, value: u.ID, Amount: u.Amount, QuickbookId: u.QuickbookId, AccountName : u.AccountName};
      });

      let appointmentPersonOptions = [];
      let UserType = [];
      const Person = AppointmentForPerson.map((u, i) => {
        if (u.IsCustomer == 1) {
          UserType = "Customer";
        } else if(u.IsCustomer == 2) {
          UserType = "Employee";
        }else{
          UserType = "Supplier";
        }
        appointmentPersonOptions[i] = {
          label: u.FirstName + " " + `   (${UserType})`,
          value: u.Id,
          IsCustomer: u.IsCustomer,
          AppointmentQuickbookId: u.QuickBookId
        };
      });


      const filterData = (accountName) => {
        if (accountName === "Accounts Payable (A/P)") {
            return appointmentPersonOptions.filter(item => item.IsCustomer === 0);
        } else if (accountName === "Accounts Receivable (A/R)") {
            return appointmentPersonOptions.filter(item => item.IsCustomer === 1);
        } else {
            return appointmentPersonOptions;
        }
    };



      // console.log(categoryOption,"categoryOption")

      return (
        <>
        {/* {data ? <JournalEntry sumdebit={sumdebit} sumcredit={sumcredit}/>: */}
        <tr key={index}>
          <td>
            <Select
             value={categoryOption.find((item,index)=>item.value==accountid)}
              onChange={(event) => handleVariation(index, event)}
              options={categoryOption}
              backspaceRemovesValue={false}
              controlShouldRenderValue={true}
              // hideSelectedOptions={true}
              isClearable={false}
              id="accountid"
              name="accountid"
              styles={CUSTOM_SELECT_DROPDOWN_STYLE }
              className="custom-search-select"
            />
          </td>
          <td>
            <input
              type="number"
              className="form-control form-control-sm"
              name="debits"
              value={debits}
              onChange={(evnt) =>
                handleInputBoxChange(index, "debits", evnt.target.value)
              }
              // onClick={(evnt)=>handleInputClick("debits")}
            />
          </td>
          <td>
            <input
              type="number"
              className="form-control form-control-sm"
              name="credits"
              value={credits}
              onChange={(evnt) =>
                handleInputBoxChange(index, "credits", evnt.target.value)
              }
              // onClick={(evnt)=>handleInputClick("credits")}
            />
          </td>
          <td>
            <input
              type="text"
              className="form-control form-control-sm"
              name="description"
              value={description}
              onChange={(evnt) => handleChange(index, evnt)}
            />
          </td>
          <td>
            <Select
              onChange={(event) => {
                handleName(index, event);
                handleUserType(index, event);
              }}
              // options={appointmentPersonOptions}
              options={filterData(AccountName)}
              backspaceRemovesValue={false}
              controlShouldRenderValue={true}
              styles={CUSTOM_SELECT_DROPDOWN_STYLE }
              id="userid"
              name="userid"
              value={filterData(AccountName)?.filter(el=> el?.IsCustomer == usertype).find((item,index)=>item.value==userid)}
              className="custom-search-select"
              isDisabled={ accountid ? false : true}
              isClearable={false}
            />
          </td>

          <td>
            <i
              className="fa fa-trash text-red fa-2x"
              data-bs-toggle="tooltip"
              title="Delete"
              onClick={() => handleDeleteClick(index)}
              data-bs-backdrop="static"
              data-bs-keyboard="false"
            />
            {/* Delete confirmation modal */}
            <div
              className={`modal ${showDeleteModal ? "d-block" : ""} `}
              tabIndex="-1"
            >
              <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h6 className="modal-title">Confirmation</h6>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={handleClose}
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-lg-12">
                        <p>Are you sure you want to delete this row?</p>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer justify-content-center">
                    {/* {checkUserPermission(PERMISSION_DELETE) ? ( */}
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleConfirmDelete}
                    >
                      Delete
                    </button>
                    {/* ) : (
                      ""
                    )} */}
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handleCancelDelete}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>

     {/* {data ? <JournalEntry sumdebit={sumdebit} sumcredit={sumcredit}/> : ""} */}
        </>
      );
     
    });
   
    
}
